export const ParcelQ_Card_Class =
  "border border-pq-border bg-pq-bg-elevated shadow-sm shadow-amber-950/5";

export const ParcelQ_Card_Header_Class =
  "border-b border-pq-border bg-pq-bg-soft px-4 py-3";

export const ParcelQ_Input_Class =
  "rounded-lg border border-pq-border-strong bg-pq-input px-4 text-sm text-pq-fg outline-none placeholder:text-pq-fg-subtle focus:border-amber-500 focus:ring-2 focus:ring-amber-400/30";

export const ParcelQ_Btn_Primary_Class =
  "rounded-lg bg-gradient-to-r from-amber-600 to-amber-500 px-6 py-2.5 text-xs font-semibold uppercase tracking-wider text-white transition hover:from-amber-500 hover:to-amber-400";

export const ParcelQ_Btn_Secondary_Class =
  "rounded-lg border border-pq-border-strong bg-pq-bg-elevated px-6 py-2.5 text-xs font-medium uppercase tracking-wider text-pq-fg-muted transition hover:border-amber-500 hover:text-amber-800 dark:hover:text-amber-200";

export const ParcelQ_Label_Mono_Class =
  "font-mono text-xs uppercase tracking-widest text-pq-fg-subtle";

export const ParcelQ_Heading_Class = "font-semibold tracking-tight text-pq-fg";
